<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-6"></a>
<h2 class="chapter">    Timeline of Events</h2>
<p class="nonindent1">June 1941: Having conquered most of Western Europe, Adolf Hitler turned his attention to the vast Soviet Union. Disregarding his Non-Aggression Pact with Joseph Stalin, Hitler launched Operation <em class="italic">Barbarossa</em>, a fullscale invasion of the Soviet homeland—aimed squarely at Moscow. In the skies over Russia, the battle-hardened airmen of the Luftwaffe made short work of the Red Air Force during the opening days of <em class="italic">Barbarossa</em>. To make matters worse, Stalin had executed many of his best pilots during the perennial purges of the 1930s. Thus, much of the Red Air Force was destroyed on the ground before meeting the Luftwaffe in the skies. By 1944, however, the Soviet airmen had regained the initiative and fervently wrested air superiority from the now-ailing Axis Powers.</p>
<div class="img_container"><img alt="image" src="images/Img_6_001.jpg"/></div>
<a id="VPS-7"></a>
<div class="img_container"><img alt="image" src="images/Img_7_001.jpg"/></div>
<div class="block-blue">
<p class="non-w1">A flight of Bf 109s in formation over the Eastern Front. By 1943, although still a champion fighter of the Luftwaffe, the Bf 109 was beginning to meet its match against the latter-day variants of the Yakovlev and Lavochkin fighters.</p>
</div>
<div class="img_container">
<img alt="image" src="images/Img_7_003.jpg"/>
</div>
<div class="img_container">
<img alt="image" src="images/Img_7_002.jpg"/>
<p class="non-w1">Il-2s from the 16th Air Army prepare to get airborne on another strafing run against German armored units.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Chapter_1.vue?227759c4